//
//
//
//

import StatusSelectDialog from './StatusSelectDialog'
import Promotor from '@/api/promotores/usuarios.api'

export default {
  props: {
    value: {
      type: String | undefined,
      required: true
    },
    promotorId: {
      type: Number | undefined,
      required: true
    }
  },

  data() {
    return {
      loading: false,      
    }
  },

  computed: {
    status: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },

  methods: {
    selectStatus() {
      const dialog = this.$q.dialog({
        component: StatusSelectDialog,
        status: this.status,
      })

      dialog.onOk(async (status) => {
        try {
          this.loading = true
          await Promotor.estatus(this.promotorId, status)
          this.status = status
          dialog.hide()
        } finally {
          this.loading = false
        }
      })
    }
  }
}
